var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.667 141.667",
    style: {
      enableBackground: "new 0 0 141.667 141.667"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A8D2FF",
    d: "M75.264,115.88c0-1.172-0.01-4.256-0.01-6.704c0-6.125,3.617-16.105,14.782-28.741     c2.812-3.181,4.736-5.569,8.296-7.274l0.396,12.821l34.338-21.235L97.502,45.642l0.554,18.152     c-6.068,2.165-10.125,5.775-14.603,10.85c-3.539,4.011-6.302,7.67-8.522,11.22V60.852h14.071L70.806,25.787l-18.25,35.065H66.63     l0.054,25.012c-1.981-2.925-4.358-8.002-7.202-11.22c-4.478-5.075-9.803-8.685-15.872-10.856l0.554-18.146L8.6,64.748l34.337,21.235     l0.396-12.821c3.561,1.705,6.747,4.093,9.564,7.274c8.843,9.998,12.992,22.585,12.992,28.741v6.704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.b90c768e0f6b71ee3621f43936589991.svg";
export { ForwardRef as ReactComponent };